import React from "react";
import FaqManager from "components/app/tool/faq/FaqManager";

type ScreenFaqProps = React.PropsWithChildren<{
	match: {
		params: {
			pageNumber: string;
		};
	};
}>;

function ScreenFaq(props: ScreenFaqProps) {
	return <FaqManager />;
}

export default ScreenFaq;


